module.exports = __webpack_public_path__ + "static/media/Slot.31f2457b.svg";